import { Extension } from '@tiptap/core';
import { NodeControlPlugin } from './NodeControlPlugin.js';

const NodeControl = Extension.create({
  name: "nodeControl",
  addProseMirrorPlugins() {
    return [
      NodeControlPlugin()
    ];
  }
});

export { NodeControl };
//# sourceMappingURL=NodeControlExtension.js.map
